import { stringify } from 'query-string'
import { useLocation } from 'react-router-dom'

export const getParams = search => {
  const searchParams = new URLSearchParams(search)
  const result = {}
  for (const [key, value] of searchParams) {
    result[key] = value
  }
  return result
}

export const stringifySearchParams = search => {
  return stringify(search, {
    skipNull: true
  })
}

const useSearchParams = () => {
  const location = useLocation()
  const result = getParams(location.search)
  return result
}

export default useSearchParams
